import NavigationItem, {
  NavigationItemType,
} from '@components/Navigation/NavigationItem';
import { faClock, faEuroSign } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppBar, Container, List, Toolbar } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { getRouteByName } from '@plugins/router/default';
import OverrideTheme from 'themes/custom-theme-helper';

import { FeatureFlags } from '@/web/src/constants/feature-flags';

const useStyles = makeStyles(() => ({
  navigationAppBar: {
    ...OverrideTheme.ui.lightCard(),
    borderRadius: 0,
    color: OverrideTheme.colors.textPrimary,
    boxShadow: '0 2px 10px 0 rgba(39,39,39, 0.12)',
  },
  navigationToolbar: {
    minHeight: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  navigationList: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    '& a': {
      color: OverrideTheme.colors.textPrimary,
    },
  },
}));

const navigationItems: NavigationItemType[] = [
  {
    name: 'timesheet',
    label: 'navigation.links.timesheet',
    icon: <FontAwesomeIcon icon={faClock} size="lg" />,
    dropdownItems: [
      {
        label: 'navigation.links.a_traiter',
        route: getRouteByName('navigation.links.dashboard'),
      },
      {
        label: 'navigation.links.imports',
        route: getRouteByName('navigation.links.import_index'),
      },
      {
        label: 'navigation.links.history_actions',
        route: getRouteByName('navigation.links.history_actions'),
      },
      {
        label: 'navigation.links.referentials',
        route: getRouteByName('navigation.links.referentials'),
        featureFlag: FeatureFlags.CLIENT_REFERENTIAL_ENABLED,
      },
    ],
    activeFor: [
      'home',
      'timesheet',
      'import',
      'imports',
      'import-create',
      'history-actions',
      'referentials',
    ],
  },
  {
    name: 'advance',
    label: 'navigation.links.advance',
    icon: <FontAwesomeIcon icon={faEuroSign} size="lg" />,
    dropdownItems: [
      {
        label: 'navigation.links.advance_manage_request',
        route: getRouteByName('navigation.links.advance_manage_request'),
      },
      {
        label: 'navigation.links.advance_history',
        route: getRouteByName('navigation.links.advance_history'),
      },
      {
        label: 'navigation.links.advance_manage_unavailabilities',
        route: getRouteByName(
          'navigation.links.advance_manage_unavailabilities',
        ),
      },
    ],
    activeFor: [
      'advance-requests-history',
      'advance-requests-list',
      'advance-periods-edit',
      'advance-periods-list',
    ],
  },
];

const NavigationTop = () => {
  const classes = useStyles();

  return (
    <AppBar position="static" className={classes.navigationAppBar}>
      <Container maxWidth="xl">
        <Toolbar className={classes.navigationToolbar}>
          <List disablePadding className={classes.navigationList}>
            {navigationItems.map((item) => (
              <NavigationItem item={item} key={item.name} />
            ))}
          </List>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default NavigationTop;
